
import React from 'react';
import { TextField, TextFieldProps } from '../../../ui-kit';
import Field, { FieldProps } from './Field';

export type InputFieldProps<P> = Omit<FieldProps<P, TextFieldProps>, 'renderer'>;

const InputField = <P, >(props: InputFieldProps<P>) => (
    <Field
        renderer={TextField}
        inputProps={{
            step: props.type === 'number' ? 'any' : undefined
        }}
        {...props}
    />
);

export default InputField;
